import React, { Component } from 'react';
import { connect } from 'react-redux';

import axiosInstance from '../../../../../../_helpers/axiosConfig'
import { authHeader } from '../../../../../../_helpers/auth-header'
import { setSupportImage } from '../../../../../../_actions/question-library.action'

class ImageUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isUploading: false,
      selectedFile: null
    }

    this.onFileUpload = this.onFileUpload.bind(this);
  }

  onFileChange = event => {
    this.setState({ selectedFile: event.target.files[0] });
  };

  onFileUpload = event => {
    this.setState({ isUploading: true });

    // Create an object of formData 
    const formData = new FormData();

    // Update the formData object 
    formData.append(
      "file",
      this.state.selectedFile,
      this.state.selectedFile.name
    );

    // Request made to the backend api 
    // Send formData object 
    axiosInstance.request({
      url: `${process.env.REACT_APP_API_URL}/api/v2/binary`,
      method: 'POST',
      data: formData,
      headers: authHeader()
    })
      .then((response) => {
        this.setState({
          isUploading: false
        })

        this.props.dispatch(setSupportImage(this.props.question, response.data.url));
      })
      .catch(() => {
        this.setState({
          isUploading: false
        })
      })

  }

  render() {
    return <div className="form-group">
      <label htmlFor="question"><strong>Image</strong></label>
      <input onChange={this.onFileChange} type="file" />
      <button
        onClick={this.onFileUpload}
        disabled={this.state.isUploading}
        type="button" className="btn btn-secondary mt-2">{`${this.state.isUploading ? 'Uploading' : 'Upload'}`}</button>
    </div>
  }
}

export default connect()(ImageUpload);